module.exports = __webpack_public_path__ + "img/icon-map-pin.f90707cb.svg";